import type { GivingFeaturedItem } from '@percent/admin-dashboard/api/types'

export const objectKeys = <T extends object>(obj: T): (keyof T)[] => Object.keys(obj) as (keyof T)[]

// The id field on a featured item depends on its kind — resolve it to a single string for display.
export const getFeaturedItemId = (item: GivingFeaturedItem): string => {
  if (item.kind === 'featured_organisation') return item.organisationId

  if (item.kind === 'featured_fundraiser') return item.fundraiserId

  return item.opportunityId
}

// error is withheld until the matching save settles (savingKey matches, no longer saving)
export const makeErrorForKey =
  (savingKey: string | null, isSaving: boolean, mutationError?: string) =>
  (key: string): string | undefined =>
    savingKey === key && !isSaving ? mutationError : undefined

export const isValidUrl = (val: string) => {
  try {
    return ['https:', 'http:'].includes(new URL(val).protocol)
  } catch {
    return false
  }
}
